/** Category labels for AI analysis groups — severity colors live in tokens.css. */

export type CategoryId = "needsAttention" | "needsReview" | "compliant";

export const categoryMeta: Record<
  CategoryId,
  {
    label: string;
    shortLabel: string;
    /** CSS var for bars / markers only — never for body text. */
    sevVar: string;
  }
> = {
  needsAttention: {
    label: "Needs attention",
    shortLabel: "Attention",
    sevVar: "var(--sev-attention)",
  },
  needsReview: {
    label: "Needs review",
    shortLabel: "Review",
    sevVar: "var(--sev-review)",
  },
  compliant: {
    label: "Compliant",
    shortLabel: "Compliant",
    sevVar: "var(--sev-compliant)",
  },
};
